/**
 * API endpoints and external URLs configuration
 *
 * For React environment variables:
 * - Must start with REACT_APP_ to be accessible in browser
 * - Set in .env file or Netlify environment variables
 */

const api = {
  // Backend API for fetching fare data
  faresEndpoint: process.env.REACT_APP_FARES_API_URL || '/api/fares',

  // Netlify function endpoint for AI assistant
  geminiEndpoint: process.env.REACT_APP_GEMINI_ENDPOINT || '/.netlify/functions/askGemini',

  // External links — official fare source (this is where fares.json is scraped from)
  officialFaresUrl: process.env.REACT_APP_OFFICIAL_FARES_URL || 'https://www.iledefrance-mobilites.fr/en/tickets-fares',

  // Creator links
  githubUrl: 'https://github.com/swapniltamse',
  linkedinUrl: 'https://www.linkedin.com/in/swapniltamse',

  // Official Paris transit apps (App Store + Google Play)
  apps: {
    ileDeFranceMobilites: {
      name: 'Île-de-France Mobilités',
      ios: 'https://apps.apple.com/app/id484527651',
      android: 'https://play.google.com/store/apps/details?id=com.applidium.vianavigo',
    },
    bonjourRatp: {
      name: 'Bonjour RATP',
      ios: 'https://apps.apple.com/app/id507107090',
      android: 'https://play.google.com/store/apps/details?id=com.fabernovel.ratp',
    },
  },
};

export default api;
